<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">

  <app-qrcode content="https://oon.gl/EPUcmR" [size]="246"/>

  <span class="sublabel">
    Book Now
  </span>
</div>
